import {
    FETCH_DELETE_GROUPS_REQUEST,
    FETCH_DELETE_GROUPS_SUCCESS,
    FETCH_DELETE_GROUPS_FAILURE,
} from '../../actions/groups/delete-group-action';

const initialState = {
    removed: null,
    isLoading: false,
    error: null,
};

const CLEAR_DATA = "CLEAR_DATA";
const DeleteGroupReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_DELETE_GROUPS_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_DELETE_GROUPS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                removed: action.payload || true,
            };
        case FETCH_DELETE_GROUPS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case CLEAR_DATA:
            return {
                ...initialState
            };
        default:
            return state;
    }
};

export default DeleteGroupReducer;